<template>
	<view class="main-container">
		<view class="notify-title">系统通知</view>
		<view class="notify-time">发布于2023-03-12 19:00</view>
		<view class="notify-content">
			<view v-html="html"></view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				html: "<p>2133<p>"
			};
		}
	}
</script>

<style lang="scss">
.main-container {
	height: 100%;
	background-color: #fff;
	box-sizing: border-box;
	padding: 60rpx 32rpx env(safe-area-inset-bottom);
	.notify-title {
		font-size: 44rpx;
		font-weight: 500;
		color: #222222;
		line-height: 44rpx;
	}
	.notify-time {
		margin-top: 32rpx;
		height: 26rpx;
		font-size: 26rpx;
		font-weight: 400;
		color: #999999;
		line-height: 26rpx;
	}
	.notify-content {
		margin-top: 40rpx;
	}
}
</style>
